import styled from 'styled-components';
import base from './base';
import mediaQueries from './mediaQueries';

export const TitleStyled = styled.h3`
  ${base} ${mediaQueries};
`;
